import * as yup from 'yup';

export const PLANNED_RETAILER_MAX_LENGTH = 64;

export const PLANNED_RETAILER_REQUIRED_MESSAGE = 'Planned retailer is required';

export const plannedRetailerSchema = yup
  .string()
  .trim()
  .required(PLANNED_RETAILER_REQUIRED_MESSAGE)
  .max(PLANNED_RETAILER_MAX_LENGTH, `Planned retailer must be ${PLANNED_RETAILER_MAX_LENGTH} characters or fewer`)
  .matches(/^[^<>]*$/, { message: 'Planned retailer cannot contain < or >', excludeEmptyString: true })
  // Spreadsheet formula prefixes, as the API rejects them.
  .matches(/^[^=+\-@]/, { message: 'Planned retailer cannot start with =, +, - or @', excludeEmptyString: true });
